import React from 'react';
import * as styles from './Loading.module.css';

interface LoadingProps {
  size?: number;
  color?: string;
}

function Loading({ size = 45, color = 'var(--color-primary)' }: LoadingProps) {
  return (
    <span
      className={styles.spinner}
      style={{ width: size, height: size, borderTopColor: color }}
    />
  );
}

export default Loading;
